import { Typography } from "antd";
import EditLgIcon from "components/Icons/EditIconLg";
import { Modal, Table } from "components/ui-component";
import { EditButton } from "./CoverPage.style";

interface AssignedUsersModalProps {
  visible: boolean;
  onCancelClick: () => void;
  assignedUsers: any[];
  coverPage: any;
  onEditClick: (coverPage: any) => void;
}

const AssignedUsersModal = (props: AssignedUsersModalProps) => {
  const { visible, onCancelClick, assignedUsers, coverPage, onEditClick } =
    props;

  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "name",
      width: 200,
      render: (_: unknown, record: any) =>
        `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Email",
      dataIndex: "username",
      key: "email",
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onCancelClick}
      cancelText="Close"
      cancelButtonType="primary"
      isOkButton={false}
      title={
        <div className="flex justify-between items-center w-full">
          <div className="modal-title-icon">
            <div className="d-flex justify-content-between w-100 align-item-center">
              <Typography.Title level={5}>Assigned Users</Typography.Title>
              <EditButton
                onClick={() => onEditClick(coverPage)}
                title="Edit Cover Page"
                size="small"
                icon={<EditLgIcon />}
              />
            </div>
          </div>
        </div>
      }
      centered
      destroyOnClose
      closable={false}
    >
      <Table
        columns={columns}
        data={assignedUsers || []}
        pagination={false}
        scroll={{ y: 400 }}
      />
    </Modal>
  );
};

export default AssignedUsersModal;
